import { render, staticRenderFns } from "./BenefitsFeature.vue?vue&type=template&id=5ecf8edc&scoped=true"
import script from "./BenefitsFeature.vue?vue&type=script&lang=js"
export * from "./BenefitsFeature.vue?vue&type=script&lang=js"
import style0 from "./BenefitsFeature.vue?vue&type=style&index=0&id=5ecf8edc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecf8edc",
  null
  
)

export default component.exports